import React from 'react';

export const IsEditingMode = React.createContext<boolean>(false);
